import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum MessageTypeId {
  TYPE_RECEIVED = 0,
  TYPE_SENT = 1,
  TYPE_PARTNER_SENT = 2,
}

export class MessageType extends Codebook<MessageTypeId> {
  static readonly TYPE_RECEIVED = new MessageType(MessageTypeId.TYPE_RECEIVED, () =>
    $t('messageType.received'),
  )
  static readonly TYPE_SENT = new MessageType(MessageTypeId.TYPE_SENT, () => $t('messageType.sent'))
  static readonly TYPE_PARTNER_SENT = new MessageType(MessageTypeId.TYPE_PARTNER_SENT, () =>
    $t('messageType.partnerSent'),
  )

  private constructor(
    public readonly id: MessageTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
